<template>
    <el-form ref="scheduleForm" :model="scheduleForm" :rules="rules">
        <el-row>
            <el-col class="hidden-xs-only" style="width:20px">&nbsp;</el-col>
            <el-col :span="5" :xs="5">
                <el-form-item class="timepicker-col" prop="day">
                    <el-select v-model="scheduleForm.day" placeholder="请选择" size="small" @change='dayChanged'>
                        <el-option v-for="item in daysOfWeek" :key="item.value" :label="item.label" :value="item.value" :disabled="item.disabled">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="5" :xs="6">
                <el-form-item class="timepicker-col" prop="startTime">
                    <el-select v-model="scheduleForm.startTime" :disabled="scheduleForm.day==''" :clearable="true" size="small" placeholder="开始时间" @focus="onStartTimeFocus()" @change="startTimeChanged" @clear="startTimeCleared">
                        <el-option v-for="item in timesOfStartTime" :key="item.value" :label="item.label" :value="item.value" :disabled="item.disabled">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="5" :xs="6">
                <el-form-item class="timepicker-col" prop="endTime">
                    <el-select v-model="scheduleForm.endTime" :disabled="scheduleForm.day==''" :clearable="true" size="small" placeholder="结束时间" @focus="onEndTimeFocus()" @change="endTimeChanged" @clear="endTimeCleared">
                        <el-option v-for="item in timesOfEndTime" :key="item.value" :label="item.label" :value="item.value" :disabled="item.disabled">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="5" :xs="5">
                <el-form-item class="timepicker-col" prop="universityCourseType">
                    <el-select v-model="scheduleForm.universityCourseType" :disabled="scheduleForm.day==''" :clearable="true" size="small" placeholder="课程类型">
                        <el-option v-for="item in courseTypeList" :key="item.Key" :label="item.Value" :value="item.Key">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="1">
                <el-button class="timepicker-col-close" v-if="rowIndex>0" type="text" @click="deleteRow">
                    <i class="el-icon el-icon-close delete-row-icon"></i>
                </el-button>
            </el-col>
        </el-row>
    </el-form>
</template>

<style lang="scss" scoped>
  .timepicker-col {
        width: auto;
    }
</style>

<script>
import { srcDaysOfWeek, srcTimesOfDay } from "../service/api-base.service";
import { getStore, getUniversityCourseTypeList } from "../config/mUtils";
export default {
  props: [
    "rowIndex",
    "isSameAsAbove",
    "scheduleForm",
    "timeLeft",
    "unavailbeTime",
    "currentSchedulesAll"
  ],
  data() {
    let _self = this;
    let startTimeValidator = (rule, value, callback) => {
      if (value === "") {
        return callback(new Error("请选择开始时间"));
      } else if (_self.scheduleForm.endTime !== "") {
        let timeSpan = parseInt(_self.scheduleForm.endTime) - parseInt(value);
        if (timeSpan < _self.courseSpan) {
          return callback(new Error("时间跨度至少应为1小时"));
        }
        return callback();
      } else {
        return callback();
      }
    };
    let endTimeValidator = (rule, value, callback) => {
      if (value === "") {
        return callback(new Error("请选择结束时间"));
      } else if (_self.scheduleForm.startTime !== "") {
        let timeSpan = parseInt(value) - parseInt(_self.scheduleForm.startTime);
        if (timeSpan < _self.courseSpan) {
          return callback(new Error("时间跨度至少应为1小时"));
        }
        return callback();
      } else {
        return callback();
      }
    };
    let dayValidator = (rule, value, callback) => {
      if (value === "") {
        return callback(new Error("请选择日期"));
      } else if (this.$props.unavailbeTime) {
        _self.$props.unavailbeTime.forEach((u, i) => {
          if (
            _self.$props.scheduleForm.id !== u.id &&
            _self.$props.scheduleForm.day === u.day &&
            ((parseInt(u.startTime) <=
              parseInt(_self.$props.scheduleForm.startTime) &&
              parseInt(u.endTime) >
                parseInt(_self.$props.scheduleForm.startTime)) ||
              (parseInt(u.startTime) >=
                parseInt(_self.$props.scheduleForm.startTime) &&
                parseInt(u.startTime) <
                  parseInt(_self.$props.scheduleForm.endTime)))
          ) {
            let couseName = "";
            if (u.courseName) couseName = u.courseName;
            return callback(
              new Error(
                "当前时间段与" +
                  couseName +
                  _self.daysOfWeek[parseInt(u.day) - 1].label +
                  "冲突"
              )
            );
          }
        });
        return callback();
      } else {
        return callback();
      }
    };
    return {
      courseSpan: 60,
      daysOfWeek: [],
      courseTypeList:[],
      selfTimeLeft: 0,
      timesOfDay: srcTimesOfDay(),
      timesOfStartTime: srcTimesOfDay(),
      timesOfEndTime: srcTimesOfDay(),
      rules: {
        day: [
          {
            validator: dayValidator,
            trigger: "blur"
          }
        ],
        startTime: [
          {
            validator: startTimeValidator,
            trigger: "blur"
          }
        ],
        endTime: [
          {
            validator: endTimeValidator,
            trigger: "blur"
          }
        ],
        universityCourseType:[
          {
            required: true,
            message:"课程类型是必需的",
            trigger:"blur"
          }
        ]
      }
    };
  },
  created() {
    this.courseTypeList = getUniversityCourseTypeList();
    let daysOfWeekList = srcDaysOfWeek();
    let hasSaturdayCourse = getStore("user_student_hasSaturdayCourse");
    let hasSundayCourse = getStore("user_student_hasSundayCourse");
    if (hasSaturdayCourse != "1") {
      daysOfWeekList[5].disabled = true;
    }
    if (hasSundayCourse != "1") {
      daysOfWeekList[6].disabled = true;
    }
    this.daysOfWeek = daysOfWeekList;
    this.computeSelfTimeLeft();
  },
  methods: {
    validateRow() {
      let validResult = false;
      this.$refs.scheduleForm.validate(valid => {
        validResult = valid;
      });
      return validResult;
    },
    onStartTimeFocus() {
      this.$emit("editRow", this.$props.scheduleForm.id);
      this.$data.timesOfDay.forEach((item, index) => {
        if (index == 0) {
          if (this.$props.rowIndex > 0 && this.$props.isSameAsAbove)
            item.disabled = false;
        } else {
          item.disabled = false;
        }
        item.hide = false;
        if (this.$props.scheduleForm.endTime > 0) {
          if (
            item.value >
              parseInt(this.$props.scheduleForm.endTime) - this.courseSpan ||
            item.value <
              parseInt(this.$props.scheduleForm.endTime) - this.selfTimeLeft
          ) {
            item.disabled = true;
            item.hide = true;
          }
        }
        if (this.$props.unavailbeTime) {
          this.$props.unavailbeTime.forEach((u, i) => {
            if (
              this.$props.scheduleForm.id !== u.id &&
              this.$props.scheduleForm.day === u.day
            ) {
              if (
                this.$props.scheduleForm.endTime > 0 &&
                this.$props.scheduleForm.endTime > parseInt(u.endTime) &&
                parseInt(item.value) < parseInt(u.endTime)
              ) {
                item.disabled = true;
              }
              if (
                parseInt(item.value) >
                  parseInt(u.startTime) - this.courseSpan &&
                parseInt(item.value) < parseInt(u.endTime)
              ) {
                item.disabled = true;
              }
            }
          });
        }
      });
      this.timesOfStartTime = [];
      this.$data.timesOfDay.forEach((item, index) => {
        if (!item.hide) {
          this.timesOfStartTime.push(item);
        }
      });
    },
    onEndTimeFocus() {
   
      this.$emit("editRow", this.$props.scheduleForm.id);
      this.$data.timesOfDay.forEach((item, index) => {
        if (index == 0) {
          if (this.$props.rowIndex > 0 && this.$props.isSameAsAbove)
            item.disabled = false;
        } else {
          item.disabled = false;
        }
        item.hide = false;
        if (this.$props.scheduleForm.startTime > 0) {
          if (
            item.value <
              parseInt(this.$props.scheduleForm.startTime) + this.courseSpan ||
            item.value >
              parseInt(this.$props.scheduleForm.startTime) + this.selfTimeLeft
          ) {
            item.disabled = true;
            item.hide = true;
          }
        }
        if (this.$props.unavailbeTime) {
          this.$props.unavailbeTime.forEach((u, i) => {
            if (
              this.$props.scheduleForm.id !== u.id &&
              this.$props.scheduleForm.day === u.day
            ) {
              if (
                this.$props.scheduleForm.startTime > 0 &&
                this.$props.scheduleForm.startTime < parseInt(u.startTime) &&
                parseInt(item.value) > parseInt(u.startTime)
              ) {
                item.disabled = true;
              }
              if (
                parseInt(item.value) > parseInt(u.startTime) &&
                parseInt(item.value) < parseInt(u.endTime) + this.courseSpan
              ) {
                item.disabled = true;
              }
            }
          });
        }
      });
      this.timesOfEndTime = [];
      this.$data.timesOfDay.forEach((item, index) => {
        if (!item.hide) {
          this.timesOfEndTime.push(item);
        }
      });
    },
    dayChanged(value) {
      this.$emit("editRow", this.$props.scheduleForm.id);
      this.$refs.scheduleForm.validate(valid => {
        if (!valid) {
          return;
        }
        this.$emit("reduceTime", this.$props.scheduleForm.id);
      });
    },
    startTimeChanged(value) {
      if (
        value === 0 &&
        this.$props.unavailbeTime &&
        this.$props.unavailbeTime.length > 0
      ) {
        let currentUnailbeTime = this.$props.currentSchedulesAll;
        if (currentUnailbeTime.length > 1) {
          this.onEndTimeFocus();
          let index = currentUnailbeTime.length - 2;
          this.$props.scheduleForm.startTime =
            currentUnailbeTime[index].startTime;
          this.$props.scheduleForm.endTime = currentUnailbeTime[index].endTime;
        }
      }
      this.$refs.scheduleForm.validate(valid => {
        if (!valid) {
          if (value === 0) {
            this.$props.scheduleForm.startTime = "";
            this.$props.scheduleForm.endTime = "";
          }
          return;
        }
        this.$emit("reduceTime", this.$props.scheduleForm.id);
      });
    },
    endTimeChanged(value) {
      if (
        value === 0 &&
        this.$props.unavailbeTime &&
        this.$props.unavailbeTime.length > 0
      ) {
        let currentUnailbeTime = [];
        this.$props.unavailbeTime.forEach((u, i) => {
          if (u.couseName === this.$props.scheduleForm.couseName) {
            currentUnailbeTime.push(u);
          }
        });
        if (currentUnailbeTime.length > 0) {
          this.onStartTimeFocus();
          let index = currentUnailbeTime.length - 1;
          this.$props.scheduleForm.startTime =
            currentUnailbeTime[index].startTime;
          this.$props.scheduleForm.endTime = currentUnailbeTime[index].endTime;
        }
      }
      this.$refs.scheduleForm.validate(valid => {
        if (!valid) {
          if (value === 0) {
            this.$props.scheduleForm.startTime = "";
            this.$props.scheduleForm.endTime = "";
          }
          return;
        }
        this.$emit("reduceTime", this.$props.scheduleForm.id);
      });
    },
    startTimeCleared() {
      this.$emit("reduceTime", this.$props.scheduleForm.id);
    },
    endTimeCleared() {
      this.$emit("reduceTime", this.$props.scheduleForm.id);
    },
    deleteRow() {
      this.$emit("deleteRow", this.$props.scheduleForm.id);
    },
    computeSelfTimeLeft() {
      this.selfTimeLeft = this.timeLeft;
      if (
        this.scheduleForm &&
        this.scheduleForm.startTime !== "" &&
        this.scheduleForm.endTime !== ""
      ) {
        let timeSpan =
          parseInt(this.scheduleForm.endTime) -
          parseInt(this.scheduleForm.startTime);
        //if(this.timeLeft < timeSpan){
        this.selfTimeLeft = timeSpan + this.timeLeft;
        //}
      }
    }
  },
  watch: {
    timeLeft: function() {
      this.computeSelfTimeLeft();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/courseScheduleTimePicker.vue